/* tslint:disable:no-console */
import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {timer, zip} from 'rxjs';
import {Page, PortalApiService, SearchCriteria} from '../../modules/record/portal-api.service';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {CoreService, LookupLists} from "../../modules/core.service";
import {
  Identification,
  IdentificationSearchResult,
  IdentificationSelector
} from "../../modules/record/identification-models";
import {IdentificationWithDataset} from "../identification/identification.component";
import {BaseService} from "../../modules/base/base.service";
import {IdWithIndex} from "../../modules/base/base.module";
import {UserService} from "../../modules/user/user.service";

@Component({
  selector: 'ae-identification-list',
  templateUrl: './identification-list.component.html',
  styleUrls: ['./identification-list.component.scss']
})
export class IdentificationListComponent implements OnInit {
  currentIdentificationId!: string | null;
  selectedIdentification: IdentificationSelector | null = null;
  currentIdentification: Identification | null = null;
  currentIdentificationWithDataset: IdentificationWithDataset | null = null;
  searchResult: IdentificationSearchResult[] | null = null;
  searchDataset: string | null = null;
  lookups: LookupLists = new LookupLists([]);
  searchCriteria!: SearchCriteria;
  datasetNames: string[] = [];

  searchError = false;
  searchResultCount = 0;
  pageSize = 20;
  pageSizeOptions = [5, 10, 15, 20, 25, 50];
  @ViewChild('paginator')
  paginator!: MatPaginator;
  @ViewChild('authTop')
  authTopElement!: ElementRef;
  @ViewChildren('authList')
  authListElements!: QueryList<ElementRef>;

  customer = "";
  isSuperuser = false;

  constructor(private recordApi: PortalApiService, private coreSvc: CoreService, private baseSvc: BaseService, private userSvc: UserService) {
  }

  ngOnInit(): void {
    this.customer = this.baseSvc.appConfig().customerName;

    this.coreSvc.getLookupLists().subscribe(lookups => {
      this.lookups = lookups;
      this.datasetNames = this.lookups.dataSets.map(dsRole => dsRole.name);
    });

    this.userSvc.currentUser().subscribe(user => {
      this.isSuperuser = user.superuser;
    });
  }

  public searchHandler(searchCriteria: SearchCriteria): void {
    this.searchResult = null;
    this.currentIdentificationId = null;
    this.searchCriteria = searchCriteria;
    this.doSearch(true);
  }

  public resetHandler(): void {
    this.searchResult = null;
    this.paginator.pageIndex = 0;
    this.searchResultCount = 0;
    this.clearCapture();
  }

  pageHandler(event: PageEvent): void {
    this.currentIdentificationId = null;
    this.pageSize = this.paginator.pageSize;
    this.doSearch();
  }

  identificationChangeHandler(event: IdWithIndex): void {
    this.currentIdentificationId == event.id ? this.clearCapture() : this.viewCapture(event.index, event.id);
  }

  doSearch(resetPage = false): void {
    if (this.searchCriteria) {
      if (resetPage) {
        this.paginator?.firstPage();
      }
      this.searchDataset = this.searchCriteria.dataset;
      this.searchCriteria.page = new Page(this.paginator?.pageIndex || 0, this.pageSize);
      const searchStream = this.recordApi.searchIdentifications(this.searchCriteria);
      const countStream = this.recordApi.identificationSearchCount(this.searchCriteria);
      zip(searchStream, countStream).subscribe({
        next: ([records, cnt]) => {
          this.searchError = false;
          this.searchResult = records;
          this.searchResultCount = cnt;
          this.searchDataset = this.searchCriteria?.dataset;
        },
        error: errors => {
          this.searchError = true;
          this.searchResultCount = 0;
          this.searchResult = [];
          console.error('error searching authentications', errors);
        }
      });
    }
  }

  protected clearCapture(): void {
    this.currentIdentificationId = null;
    this.currentIdentification = null;
    this.currentIdentificationWithDataset = null;
    this.selectedIdentification = null;
  }

  protected viewCaptureAndScroll(id: string, i: number, scroll: boolean): void {
    if (i > -1 && id && this.searchDataset) {
      this.currentIdentificationId = id;
      this.recordApi.getIdentification(id, this.searchDataset)
        .subscribe(identification => {
          this.currentIdentification = identification
          this.currentIdentificationWithDataset = {
            identification: this.currentIdentification,
            dataset: this.searchDataset!
          };
          this.selectedIdentification = {identificationId: this.currentIdentificationId!, dataset: this.searchDataset!};
        });
    } else {
      this.currentIdentification = null;
      this.selectedIdentification = null;
      this.currentIdentificationWithDataset = null;
    }
    this.currentIdentificationId = id;
    if (scroll && id) {
      timer(50).subscribe(() => {
        this.authListElements.toArray()[i].nativeElement.scrollIntoViewIfNeeded({behavior: 'auto'});
        timer(250).subscribe(() => {
          this.authTopElement.nativeElement.scrollIntoViewIfNeeded({behavior: 'smooth'});
        });
      });
    }
  }

  protected viewCapture(i: number, id?: string): void {
    if (!id) {
      return;
    }
    const doScroll: boolean = this.currentIdentificationId ? false : true;
    this.viewCaptureAndScroll(id, i, doScroll);
  }

  private selectTopOfList(): void {
    if (!this.searchResult || this.searchResult.length === 0) {
      return;
    }

    const list = this.searchResult;

    if (list.length > 0) {
      let index = 0;
      if (this.currentIdentificationId) {
        index = list.findIndex(r => r.identificationId === this.currentIdentificationId);
        index = index < 0 ? 0 : index;
      }
      this.viewCaptureAndScroll(list[index]?.identificationId as string, index, true);
    } else {
      this.clearCapture();
    }
  }
}
